import { getRandomNumberBasedLeadersNames } from "../../../constants";
import { eGroup, eGroupLeader } from "../../../store/egroups/types";
import React, { FC } from "react";
import Link from "next/link";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChild } from "@fortawesome/pro-solid-svg-icons";
import Image from "next/image";
import { shimmer, toBase64 } from "../../../../js/constants";
import { useRouter } from "next/router";

interface Props {
    groupListItem: eGroup;
    idPrefix?: string;
    pageName?: string;
}

export const GroupListItem: FC<Props> = (props) => {
    const item = props.groupListItem;
    const virtualAndInPerson = item.meetingType === "In-person & Virtual";
    const router = useRouter();

    if (item && item.leaders && item.leaders.length > 0) {
        const leadersImages: JSX.Element[] = [];
        if (
            item.leaders &&
            item.leaders.length > 0 &&
            item.leaders.length < 2
        ) {
            item.leaders.forEach((leader: eGroupLeader, key: number) => {
                if (leader && leader.name && leader.profileImage) {
                    leadersImages.push(
                        <div
                            className="small-img rel-pos ec-rounded no-overflow"
                            key={leader.name + key}
                        >
                            <Image
                                className="ec-rounded"
                                layout="fill"
                                sizes="90px"
                                objectFit={"cover"}
                                objectPosition={"top"}
                                src={leader.profileImage}
                                alt="Profile Image"
                                placeholder="blur"
                                blurDataURL={`data:image/svg+xml;base64,${toBase64(
                                    shimmer(72, 72)
                                )}`}
                            />
                        </div>
                    );
                } else {
                    const leaderNameSplit = leader.name.split(" ");
                    const leaderInitials = `${leaderNameSplit[0][0]}${leaderNameSplit[1][0]}`;
                    let gradientNumber = getRandomNumberBasedLeadersNames(
                        leaderInitials,
                        1,
                        7
                    );

                    leadersImages.push(
                        <div key={leader.name + key} className="small-img">
                            <div
                                className={`egroups-leader-no-image ec-rounded rel-pos b-x-width-sm b-y-width-sm border-white full-height full-width gradient${gradientNumber}`}
                            >
                                <div className="text-center full-width abs-pos absolute-center text-white icon-xl let-sp-reg">
                                    {leaderInitials}
                                </div>
                            </div>
                        </div>
                    );
                }
            });
        } else if (item.leaders && item.leaders.length > 1) {
            // item.leaders
            //     .slice(0, 2)
            //     .forEach((leader: eGroupLeader, key: number) => {
            //         let duplicatedImg =
            //             item.leaders[0].profileImage ===
            //             item.leaders[1].profileImage;
            //         if (duplicatedImg && key === 0) {
            //         }
            //     });

            item.leaders
                .slice(0, 2)
                .forEach((leader: eGroupLeader, key: number) => {
                    let duplicatedImg =
                        item.leaders[0].profileImage ===
                        item.leaders[1].profileImage;

                    if (leader && leader.name && leader.profileImage) {
                        if (!duplicatedImg) {
                            leadersImages.push(
                                <div
                                    key={key}
                                    style={{ height: 45, width: 45 }}
                                    className="xsmall-img ec-rounded m-r-spacer-md rel-pos b-x-width-sm b-y-width-sm border-white eGroups-list-second-leader"
                                >
                                    <Image
                                        layout="fill"
                                        sizes="45px"
                                        objectFit={"cover"}
                                        objectPosition={"center"}
                                        src={leader.profileImage}
                                        alt={leader.name}
                                        placeholder="blur"
                                        className="xsmall-img ec-rounded m-r-spacer-md rel-pos b-x-width-sm b-y-width-sm border-white eGroups-list-second-leader"
                                        blurDataURL={`data:image/svg+xml;base64,${toBase64(
                                            shimmer(100, 100)
                                        )}`}
                                    />
                                </div>
                            );
                        }
                        if (duplicatedImg && key === 0) {
                            leadersImages.push(
                                <div
                                    className="small-img rel-pos ec-rounded no-overflow"
                                    key={key}
                                >
                                    <Image
                                        className="ec-rounded"
                                        sizes="90px"
                                        layout="fill"
                                        objectFit={"cover"}
                                        objectPosition={"top"}
                                        src={item.leaders[0].profileImage}
                                        alt="Profile Image"
                                        placeholder="blur"
                                        blurDataURL={`data:image/svg+xml;base64,${toBase64(
                                            shimmer(72, 72)
                                        )}`}
                                    />
                                </div>
                            );
                        }
                    } else {
                        const leaderNameSplit = leader.name.split(" ");
                        const leaderInitials = `${leaderNameSplit[0][0]}${leaderNameSplit[1][0]}`;
                        let gradientNumber = getRandomNumberBasedLeadersNames(
                            leaderInitials,
                            1,
                            7
                        );

                        leadersImages.push(
                            <div
                                key={key}
                                className="eGroups-list-second-leader xsmall-img rel-pos"
                            >
                                <div
                                    className={`egroups-leader-no-image ec-rounded rel-pos full-height b-x-width-sm b-y-width-sm border-white full-width gradient${gradientNumber}`}
                                >
                                    <div className="text-center full-width abs-pos absolute-center text-white icon-sm let-sp-reg">
                                        {leaderInitials}
                                    </div>
                                </div>
                            </div>
                        );
                    }
                });
        }
        let campus = router.query.campus;

        if (process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR == "1") {
            campus = ["toronto"];
        }

        return (
            <CSSTransition
                classNames="show-animation"
                timeout={{
                    appear: 500,
                    enter: 500,
                    exit: 300,
                }}
                appear={true}
            >
                <Link href={{ pathname: "/egroups/show/" + item.id + "/" }}>
                    <a
                        className={`${item.campusName}`}
                        id={`${
                            props.idPrefix ??
                            `cc-egroups${
                                props.pageName
                                    ? `-${props.pageName.toLowerCase()}`
                                    : ""
                            }-${campus[0]}-find`
                        }-${item.id}`}
                    >
                        <div className="flex full-width flex-align-center b-x-width-none b-t-width-none b-b-width-sm border-light-grey p-y-spacer-md rel-pos">
                            <div className="rel-pos small-box m-r-spacer-xs">
                                {leadersImages}
                            </div>
                            <div
                                className={`text-alt-dark-grey full-width ${item.slugCampusName}`}
                            >
                                {item.dayOfWeek ? (
                                    <p className="sec-font flex btn-txt m-y-spacer-none">
                                        {item.dayOfWeek}s at {item.time}{" "}
                                        {item.campusId ===
                                            "a0n46000005KAmyAAG" &&
                                        item.timeZone != null
                                            ? "(" + item.timeZone + ")"
                                            : ""}{" "}
                                        {item.childCare ? (
                                            <span
                                                className="background-childcare-blue flex flex-justify-center flex-align-center xs-icon ec-rounded m-l-spacer-xs font-size-14"
                                                title="Child Care"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faChild}
                                                    className="text-white"
                                                    aria-label="Child Care"
                                                    aria-hidden="true"
                                                />{" "}
                                            </span>
                                        ) : null}
                                    </p>
                                ) : null}
                                <p className="prim-font regular m-y-spacer-none btn-txt max-w-400 mob-max-w-275 ln-height-1-4em ec-text-grey">
                                    {item.name.length > 60
                                        ? item.name.substring(
                                              0,
                                              parseInt(
                                                  process.env
                                                      .NEXT_PUBLIC_GROUP_NAME_CHAR_COUNT ||
                                                      "60",
                                                  10
                                              )
                                          ) + "..."
                                        : item.name}
                                </p>
                                {item.egroupType || item.egroupStudy ? (
                                    <p className="prim-font regular m-y-spacer-none btn-txt max-w-400 mob-max-w-275 ln-height-1-4em ec-text-grey">
                                        {item.egroupType || ""}
                                        {item.egroupType &&
                                        item.egroupStudy &&
                                        item.egroupType !== item.egroupStudy
                                            ? " • "
                                            : ""}
                                        {item.egroupStudy &&
                                        item.egroupType !== item.egroupStudy
                                            ? item.egroupStudy
                                            : ""}
                                    </p>
                                ) : null}

                                <div className="flex m-t-spacer-xs flex-align-center">
                                    {item.meetingType && !virtualAndInPerson ? (
                                        <p className="background-off-white ec-rounded flex flex-align-center flex-justify-center font-size-12 ht-20 m-r-spacer-sm p-x-spacer-lg sec-font m-b-spacer-none">
                                            {item.meetingType}
                                        </p>
                                    ) : (
                                        <div className="flex">
                                            <p className="background-off-white ec-rounded flex flex-align-center flex-justify-center font-size-12 ht-20 m-r-spacer-sm p-x-spacer-lg sec-font m-b-spacer-none">
                                                In-person
                                            </p>
                                            <p className="background-off-white ec-rounded flex flex-align-center flex-justify-center font-size-12 ht-20 m-r-spacer-sm p-x-spacer-lg sec-font m-b-spacer-none">
                                                Virtual
                                            </p>
                                        </div>
                                    )}

                                    <p className="prim-font regular m-y-spacer-none btn-txt max-w-400 mob-max-w-275 ln-height-1-4em ec-text-grey">
                                        {item.campusName === "Winston Salem"
                                            ? "Winston-Salem"
                                            : item.campusName}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </Link>
            </CSSTransition>
        );
    }
    return null;
};
